import { render } from "./tourism.vue?vue&type=template&id=5a14a225&scoped=true"
import script from "./tourism.vue?vue&type=script&lang=js"
export * from "./tourism.vue?vue&type=script&lang=js"

import "./tourism.vue?vue&type=style&index=0&id=5a14a225&lang=scss&scoped=true"
import "./tourism.vue?vue&type=style&index=1&id=5a14a225&lang=css"

import exportComponent from "C:\\Users\\mac\\Downloads\\PCguanli\\zhongtaiworkPC\\yungong_1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a14a225"]])

export default __exports__